import { useEffect, useRef } from "react";


const useIntervalHandler = (functionCallback: () => void) => {
    const callbackRef: any = useRef(functionCallback);
    const timerId: any = useRef(null);


    useEffect(() => {
        callbackRef.current = functionCallback;
    }, [functionCallback])

    useEffect(() => {

        return () => {
            if (callbackRef.current !== null) {
                removeInterval();
                callbackRef.current = null;
            }
        }
    }, [])

    const startInterval = (delay: number) => {
        removeInterval()
        timerId.current = setInterval(() => {
            callbackRef.current()
        }, delay)
    }

    const removeInterval = () => {
        if (timerId.current !== null) {
            clearInterval(timerId.current)
            timerId.current = null;
        }
    }


    return { startInterval, removeInterval };
}

export default useIntervalHandler;